/* eslint-disable  */
import React from 'react';
import { Datagrid, TextField, ArrayField } from 'react-admin';
import WealthShowGuesser from '../../base/components/guesser/wealth-show.guesser';
import { IdField } from '../../base/components/ra/fields';

const CheatModeLinkShow = (props) => {
  return (
    <WealthShowGuesser
      {...props}
      excludeFields={['players']}
      extraAnotherBlocks={[
        <ArrayField source="players" addLabel={false}>
          <Datagrid>
            <IdField source="id" link />
            <TextField source="nativeId" />
            <IdField source="wallet.id" link label="resources.wallet.name" />
          </Datagrid>
        </ArrayField>,
      ]}
    />
  );
};

export default CheatModeLinkShow;
